<template>
  
  <div class="group" :ref="refs['widthGroup']" data-id="widthGroup">

    <div class="group-header">
      <div class="group-title"><strong>{{ builder.sectionTitle }}:</strong> <span style="font-weight: 400;">What is your <span v-html="builder.currentSectionType"></span> width?</span></div>
      <!-- <div class="group-help">Not sure? <a href="/support/how-to-measure/" target="_blank">See how to measure.</a></div> -->
    </div>
    
    <!-- <template v-if="builder.sectionsMax > 1">
      <button class="miniplan" @click.stop.prevent="builder.scrollToRef('builderTop')">
        <div class="miniplan-plan">
          <Plan
            custom-class="plan--minimal plan--no-walls"></Plan>
        </div>
        <div class="miniplan-main">
          Please provide measurements for the <strong class="l_text-blue">section&nbsp;in&nbsp;blue</strong>. Click to view section&nbsp;overview.
        </div>
      </button>
    </template> -->

    <div class="group-inputs">

      <div class="group-input">

        <Input
        key="width"
        field-label="Width"
        field-name="width"
        field-type="number"
        :init-value=initialValue
        :min=minWidth
        :max=maxWidth
        :required="true"
        :init-touched="false"
        scope="specs"
        @update-value="updateValue"
        ></Input>
        
      </div>

    </div>

    <!-- <div class="group-footer">
      
      <small>Standard maximum height 2304mm</small>
    
    </div>  -->  

  </div>
  
</template>

<script setup>
  
import { ref, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();


function updateValue(prop, val) {
  builder.setCurrentSectionSpec(prop, val);
}

const initialValue = computed(() => {
  if (!_.isUndefined(builder.currentSection) && !_.isUndefined(builder.currentSection.width)) {
    return builder.currentSection.width;
  }
  return null;
})

const maxWidth = computed(() => {
  if (!_.isNull(builder.configOptionsMaxWidth)) return builder.configOptionsMaxWidth;
  return builder.currentProductStructure.sections.sections.width.max;
})

const minWidth = computed(() => {
  if (!_.isNull(builder.configOptionsMinWidth)) return builder.configOptionsMinWidth;
  return builder.currentProductStructure.sections.sections.width.min;
})

// init refs
let refHandles = [
  'widthGroup',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>